module.exports = __webpack_public_path__ + "img/gallery_4.ca8f3093.jpg";